<template>
  <MainLayout>
    <b-row id="rssFeedManagmenet">
      <b-col class="shadow-sm">
        <h4 class="card-title font-weight-bold">
          Rss-Feed Verwaltung
        </h4>

        <b-card-body>
          <b-row>
            <RssFeedManagement class="w-100" />
          </b-row>
        </b-card-body>
      </b-col>
    </b-row>
    <div style="height: 500px" />
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import RssFeedManagement from "@/components/rssFeed/RssFeedManagement.vue";

export default {
  components: {
    MainLayout,
    RssFeedManagement,
  },
  data() {
    return {};
  },

  created() {},

  methods: {},
};
</script>

<style scoped></style>
